import ReportViewData from "./interfaces/ReportViewData";
import { getSelfServiceReport, getSelfServiceReportData } from "../service";

export const getReportViewData = async (
  reportId: string
): Promise<ReportViewData> => {
  const reportPromise = getSelfServiceReport(reportId);
  const reportDataPromise = getSelfServiceReportData(reportId);

  const report = await reportPromise;
  const reportData = await reportDataPromise;

  return { report, reportData };
};
